document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.wow-product-categories.horizontal-scroll');
    if (!section) {
        return;
    }

    const wrapper = section.querySelector('.woocommerce');
    const scrollSection = section.querySelector('ul.products');
    if (!wrapper || !scrollSection) {
        return;
    }

    const navigationLeft = document.createElement('span');
    navigationLeft.classList.add('horizontal-scroll__left');
    navigationLeft.style.display = 'none';

    const navigationRight = document.createElement('span');
    navigationRight.classList.add('horizontal-scroll__right');

    wrapper.appendChild(navigationLeft);
    wrapper.appendChild(navigationRight);

    const updateNavigationButtons = () => {
        const maxScrollLeft = scrollSection.scrollWidth - scrollSection.clientWidth;

        if (maxScrollLeft <= 0) {
            navigationLeft.style.display = 'none';
            navigationRight.style.display = 'none';
            return;
        }

        if (scrollSection.scrollLeft === 0) {
            navigationLeft.style.display = 'none';
        } else {
            navigationLeft.style.display = 'block';
        }

        if (scrollSection.scrollLeft < maxScrollLeft - 1) {
            navigationRight.style.display = 'block';
        } else {
            navigationRight.style.display = 'none';
        }
    };

    updateNavigationButtons();
    scrollSection.addEventListener('scroll', updateNavigationButtons);

    navigationLeft.addEventListener('click', () => {
        const scrollBy = window.innerWidth >= 768 ? 246 : 180;

        scrollSection.scrollBy({
            left: -scrollBy,
            behavior: 'smooth'
        });
    });

    navigationRight.addEventListener('click', () => {
        const scrollBy = window.innerWidth >= 768 ? 216 : 180;

        scrollSection.scrollBy({
            left: scrollBy,
            behavior: 'smooth'
        });
    });
});
